import Swal from 'sweetalert2';

export const handleViewJustificatif = async (justificatifPath) => {
    if (!justificatifPath) {
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Aucun justificatif associé à cette dépense.',
        confirmButtonText: 'OK'
      });
      return;
    }

    try {
      // Construire l'URL correcte selon le format du chemin
      let fullUrl;
      if (justificatifPath.startsWith('uploads/')) {
        fullUrl = `https://iti-app-nf.dev.capdigit-solutions.fr/${justificatifPath}`;
      } else if (justificatifPath.includes('/')) {
        fullUrl = `https://iti-app-nf.dev.capdigit-solutions.fr/${justificatifPath}`;
      } else {
        fullUrl = `https://iti-app-nf.dev.capdigit-solutions.fr/uploads/${justificatifPath}`;
      }
            
      const response = await fetch(fullUrl);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const blob = await response.blob();
      const fileType = blob.type;

      if (fileType.startsWith('image/')) {
        // Pour les images, afficher dans SweetAlert
        const imageUrl = URL.createObjectURL(blob);
        Swal.fire({
          imageUrl: imageUrl,
          imageAlt: 'Justificatif',
          showCloseButton: true,
          showConfirmButton: false,
          customClass: {
            popup: 'custom-swal-popup',
            image: 'custom-swal-image'
          }
        }).finally(() => {
          URL.revokeObjectURL(imageUrl);
        });
      } else {
        // Pour les PDF, ouvrir dans un nouvel onglet
        window.open(fullUrl, '_blank');
      }
    } catch (error) {
      console.error('Erreur lors du chargement du justificatif:', error);
      Swal.fire({
        icon: 'error',
        title: 'Erreur de chargement',
        html: `
          <p>Impossible de charger le justificatif.</p>
          <small style="color: #666;">Chemin: ${justificatifPath}</small>
          <br>
          <small style="color: #666;">Erreur: ${error.message}</small>
        `,
        confirmButtonText: 'OK'
      });
    }
};